import * as i18n from 'i18n-js';

export let sprintf = (string, params) => {
    let regex = /%s/;
    let _r = function(p, c) {
        return p.replace(regex, c);
    };

    return params.reduce(_r, string);
}

export const translate = (string, params = null) => {
    return params && Array.isArray(params) ? sprintf(i18n.t(string), params) : i18n.t(string);
}